import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "deduction-fix-modal" }
const _hoisted_2 = { class: "deduction-fix-modal__head" }
const _hoisted_3 = { class: "deduction-fix-modal__title" }
const _hoisted_4 = { class: "deduction-fix-modal__body" }
const _hoisted_5 = {
  key: 0,
  class: "deduction-fix-modal__current"
}
const _hoisted_6 = { class: "deduction-fix-modal__current-value" }
const _hoisted_7 = {
  key: 1,
  class: "deduction-fix-modal__auto deduction-fix-modal__auto--applied"
}
const _hoisted_8 = { class: "deduction-fix-modal__auto-head" }
const _hoisted_9 = { class: "deduction-fix-modal__auto-value" }
const _hoisted_10 = {
  key: 0,
  class: "deduction-fix-modal__auto-notes"
}
const _hoisted_11 = {
  key: 2,
  class: "deduction-fix-modal__auto"
}
const _hoisted_12 = { class: "deduction-fix-modal__auto-head" }
const _hoisted_13 = { class: "deduction-fix-modal__auto-label" }
const _hoisted_14 = { class: "deduction-fix-modal__auto-value" }
const _hoisted_15 = {
  key: 0,
  class: "deduction-fix-modal__auto-notes"
}
const _hoisted_16 = {
  key: 1,
  class: "deduction-fix-modal__auto-formula"
}
const _hoisted_17 = {
  key: 2,
  class: "deduction-fix-modal__auto-notes"
}
const _hoisted_18 = {
  key: 3,
  class: "deduction-fix-modal__no-auto"
}
const _hoisted_19 = { class: "deduction-fix-modal__no-auto-text" }
const _hoisted_20 = { class: "deduction-fix-modal__manual" }
const _hoisted_21 = ["for"]
const _hoisted_22 = { class: "deduction-fix-modal__manual-row" }
const _hoisted_23 = ["id", "value"]
const _hoisted_24 = { class: "deduction-fix-modal__footer" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWageDeductionFixModal',
  props: {
    modelValue: { type: Boolean },
    title: {},
    fieldDescription: { default: '' },
    hasAutoPreview: { type: Boolean },
    autoAmount: {},
    autoLabel: { default: '요율 기준 산출액' },
    autoButtonLabel: { default: '요율 기준 산출액 적용' },
    autoHint: { default: '' },
    appliedAmount: { default: null },
    appliedNotes: { default: '' },
    formula: { default: '' },
    notes: { default: '' },
    currentAmount: { default: 0 },
    hasCurrentAmount: { type: Boolean, default: true },
    manualOnlyMessage: { default: '직접 입력해 주세요.' },
    manualLabel: {},
    manualDisplay: {},
    inputId: {},
    formatMoney: {}
  },
  emits: ["update:modelValue", "cancel", "apply-auto", "apply-applied", "apply-manual", "manual-input"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const showAppliedAmount = computed(() => props.appliedAmount != null);

const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "440",
    persistent: "",
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.title), 1),
          _createElementVNode("button", {
            type: "button",
            class: "deduction-fix-modal__close",
            "aria-label": "닫기",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (__props.hasCurrentAmount && __props.currentAmount !== __props.autoAmount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "deduction-fix-modal__current-label" }, "현재 입력값", -1)),
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(__props.formatMoney(__props.currentAmount)), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "deduction-fix-modal__auto-unit" }, "원", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (showAppliedAmount.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "deduction-fix-modal__auto-label" }, "자동계산 금액", -1)),
                  _createElementVNode("span", _hoisted_9, [
                    _createTextVNode(_toDisplayString(__props.formatMoney(__props.appliedAmount)), 1),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "deduction-fix-modal__auto-unit" }, "원", -1))
                  ])
                ]),
                (__props.appliedNotes)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(__props.appliedNotes), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "deduction-fix-modal__auto-btn deduction-fix-modal__auto-btn--ghost",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('apply-applied')))
                }, " 자동계산 금액 사용 ")
              ]))
            : _createCommentVNode("", true),
          (__props.hasAutoPreview)
            ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(__props.autoLabel), 1),
                  _createElementVNode("span", _hoisted_14, [
                    _createTextVNode(_toDisplayString(__props.formatMoney(__props.autoAmount)), 1),
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "deduction-fix-modal__auto-unit" }, "원", -1))
                  ])
                ]),
                (__props.autoHint)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(__props.autoHint), 1))
                  : _createCommentVNode("", true),
                (__props.formula)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(__props.formula), 1))
                  : _createCommentVNode("", true),
                (__props.notes)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(__props.notes), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "deduction-fix-modal__auto-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('apply-auto')))
                }, _toDisplayString(__props.autoButtonLabel), 1)
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(__props.manualOnlyMessage), 1)
              ])),
          _createElementVNode("section", _hoisted_20, [
            _createElementVNode("label", {
              class: "deduction-fix-modal__manual-label",
              for: __props.inputId
            }, _toDisplayString(__props.manualLabel), 9, _hoisted_21),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("input", {
                id: __props.inputId,
                value: __props.manualDisplay,
                type: "text",
                class: "deduction-fix-modal__manual-input",
                inputmode: "numeric",
                placeholder: "0",
                onInput: _cache[3] || (_cache[3] = ($event: any) => (emit('manual-input', $event))),
                onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (emit('apply-manual')), ["enter"]))
              }, null, 40, _hoisted_23),
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "deduction-fix-modal__manual-unit" }, "원", -1))
            ])
          ])
        ]),
        _createElementVNode("footer", _hoisted_24, [
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "btn-cancel",
            size: "small",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('cancel')))
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode("취소", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "btn-confirm",
            size: "small",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('apply-manual')))
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("적용", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})